import React, { useEffect, useState } from "react";
import { Button as ButtonCustom } from "./../../../components/Button";
import addCircleImage from "./../../../assets/_AddCircleIcon_.svg";
import { TokenDataGrid } from "./components/DataGridApiToken";
import { CreateApiTokenModal } from "./components/ModalToken";
import {
  deleteApiToken,
  getAllApiTokens,
} from "../../../services/api/apiToken/ApiTokenService";
import { IApiTokenBody } from "../../../@types/api-token.type";
import { useConfirm } from "../../../hooks/useConfirm";
import vectorIcon from "../../../assets/_VectorIcon_.svg";
import { useNavigate } from "react-router-dom";
import Button from "@mui/material/Button";
import styles from "./styles.module.scss";

export const ApiToken: React.FC = () => {
  const [isModalCreateTokenOpen, setModalCreateTokenOpen] = useState(false);
  const [tokens, setTokens] = useState<IApiTokenBody[]>([]);
  const [loading, setLoading] = useState<boolean>(false);
  const [totalRows, setTotalRows] = useState(0);

  const [openModalConfirm, setOpenModalConfirm] = useState(false);
  const handleOpenModalConfirm = () => setOpenModalConfirm(true);
  const handleCloseModalConfirm = () => setOpenModalConfirm(false);

  const urlApi = import.meta.env.VITE_EXTERNAL_API_URL;

  const { showConfirm, Confirm } = useConfirm(
    "Tem certeza que deseja deletar o Token de API?",
    openModalConfirm,
    handleCloseModalConfirm
  );

  const navigate = useNavigate();

  const fetchTokens = async () => {
    try {
      setLoading(true);
      const response = await getAllApiTokens();
      setTokens(response);
      setTotalRows(response.length);
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchTokens();
  }, []);

  const handleDelete = async (id: string) => {
    handleOpenModalConfirm();
    const isConfirm = await showConfirm();
    if (isConfirm) {
      try {
        await deleteApiToken(id);
        fetchTokens();
      } catch (error: any) {
        console.error(error);
      }
    }
  };

  const handleModalClose = () => {
    setModalCreateTokenOpen(false);
    fetchTokens();
  };

  return (
    <div className={styles.tokenContainer}>
      <div className={styles.back}>
        <Button
          className={styles.buttonMui}
          onClick={() => navigate("/configurations")}
        >
          {vectorIcon && <img src={vectorIcon} />}
          Voltar a tela anterior
        </Button>
      </div>
      <div className={styles.titleAndBtnCreate}>
        <h1>Tokens de API</h1>
        <div className={styles.btnsFilterAndCreate}>
          <ButtonCustom
            onClick={() => window.open(urlApi)}
            content="Acessar API"
            className={styles.button}
          />
          <ButtonCustom
            iconUrl={addCircleImage}
            onClick={() => setModalCreateTokenOpen(true)}
            content="Novo Token de API"
            className={styles.button}
          />
        </div>
      </div>
      <div>
        <TokenDataGrid
          rows={tokens}
          rowCount={totalRows}
          onDelete={handleDelete}
          loading={loading}
        />
      </div>
      <CreateApiTokenModal
        open={isModalCreateTokenOpen}
        onClose={handleModalClose}
      />
      {Confirm}
    </div>
  );
};
